import {CustomFieldType} from '@frontapp/workflows/custom_fields';
import React, {ReactNode} from 'react';

import {Trans} from '../../libs/shared/core/src/helpers/internationalization/react';
import {IconName} from '../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../libs/shared/ui/src/styles/commonStyles';

export function computeCustomFieldIconName(
  customFieldType: CustomFieldType,
  size: VisualSizesEnum = VisualSizesEnum.LARGE,
): IconName {
  switch (customFieldType) {
    case CustomFieldType.TEAMMATE: {
      if (size === VisualSizesEnum.SMALL) {
        return 'participantSmall';
      }

      return 'teammateFilled';
    }
    case CustomFieldType.INBOX: {
      if (size === VisualSizesEnum.SMALL) {
        return 'inboxSmall';
      }

      return 'inboxFilled';
    }
    case CustomFieldType.DATETIME: {
      if (size === VisualSizesEnum.SMALL) {
        return 'dateSmall';
      }

      return 'dateFilled';
    }
    case CustomFieldType.NUMBER: {
      if (size === VisualSizesEnum.SMALL) {
        return 'numbersSmall';
      }

      return 'numbers';
    }
    case CustomFieldType.BOOLEAN: {
      if (size === VisualSizesEnum.SMALL) {
        return 'togglesSmall';
      }

      return 'toggles';
    }
    case CustomFieldType.TEAMMATE_LIST:
      if (size === VisualSizesEnum.SMALL) {
        return 'teammatesSmall';
      }

      return 'teammates';

    case CustomFieldType.ENUM: {
      if (size === VisualSizesEnum.SMALL) {
        return 'formattingListSmall';
      }

      return 'formattingList';
    }

    case CustomFieldType.STRING: {
      if (size === VisualSizesEnum.SMALL) {
        return 'contentSmall';
      }

      return 'content';
    }

    default:
      customFieldType satisfies never;
      return 'content';
  }
}

export function renderCustomFieldType(type: CustomFieldType): ReactNode {
  switch (type) {
    case CustomFieldType.BOOLEAN:
      return <Trans id="custom-fields-type-boolean">Yes or no</Trans>;
    case CustomFieldType.DATETIME:
      return <Trans id="custom-fields-type-datetime">Date and time</Trans>;
    case CustomFieldType.INBOX:
      return <Trans id="custom-fields-type-inbox">Inbox</Trans>;
    case CustomFieldType.NUMBER:
      return <Trans id="custom-fields-type-number">Number</Trans>;
    case CustomFieldType.TEAMMATE:
      return <Trans id="custom-fields-type-teammate">Teammate</Trans>;
    case CustomFieldType.ENUM:
      return <Trans id="custom-fields-type-enum">Dropdown</Trans>;
    case CustomFieldType.STRING:
    default:
      return <Trans id="custom-fields-type-string">Text</Trans>;
  }
}
